<template>
  <div class="content">
    <form>
      <kassaorder-form :datas="dataall"></kassaorder-form>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
      <asos :datas="dataall"></asos>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.order.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { KassaorderForm, Sklad, Paytype, Asos } from "@/pages";
export default {
  components: { KassaorderForm, Sklad, Paytype, Asos },
  data() {
    return {
      watch: false,
      update_password: "",
      dataall: ""
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  mounted() {
    this.Data();
    this.Sklad();
  },
  methods: {
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push(this.$root.$refs.order.returnLocation);
      },
    Data() {
      let self = this;
      axios
        .get("api/v1/kassa-order/id/" + self.$route.params.id)
        .then(function(response) {
          self.dataall = response.data;
          setTimeout(() => {
            self.watch = null;
          }, 100);
                  self.$store.state.saved = null;
        });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
        });
    }
  }
};
</script>
